// Relative on purpose: routes.ts loads this before Vite aliases exist.
import { ROUTES } from '../../../constants/routes.constants';

const ROOT = ROUTES.COURSES;
const ADMIN = `${ROOT}/admin`;

/**
 * Route patterns of the courses module. The original app lived at the site root; everything
 * now sits under `/courses`, and the former `/` dashboard is the module's landing page.
 */
export const COURSES_ROUTES = {
	ROOT,
	LIST: `${ROOT}/all`,
	COURSE: `${ROOT}/:courseId`,
	COURSE_COMMUNITY: `${ROOT}/:courseId/community`,
	COURSE_DISCUSSION: `${ROOT}/:courseId/community/:discussionId`,
	COURSE_OFFICE_HOURS: `${ROOT}/:courseId/office-hours`,
	MODULES: `${ROOT}/modules`,
	MODULE: `${ROOT}/modules/:moduleId`,
	LESSON: `${ROOT}/modules/:moduleId/lessons/:lessonId`,
	CHALLENGES: `${ROOT}/challenges`,
	CHALLENGE: `${ROOT}/challenges/:challengeId`,
	BOOKING: `${ROOT}/office-hours/bookings/:bookingId`,
	SUPPORT: `${ROOT}/support`,
	UNSUBSCRIBE: `${ROOT}/unsubscribe`,
	ADMIN,
	ADMIN_ANALYTICS: `${ADMIN}/analytics`,
	ADMIN_AMA: `${ADMIN}/ama`,
	ADMIN_CHALLENGES: `${ADMIN}/challenges`,
	ADMIN_CHALLENGE: `${ADMIN}/challenges/:challengeId`,
	ADMIN_CONTROLS: `${ADMIN}/controls`,
	ADMIN_COURSES: `${ADMIN}/courses`,
	ADMIN_COURSE: `${ADMIN}/courses/:courseId`,
	ADMIN_COURSES_ACCESS: `${ADMIN}/courses/access`,
	ADMIN_EMAILS: `${ADMIN}/emails`,
	ADMIN_GRADING: `${ADMIN}/grading`,
	ADMIN_MODULES: `${ADMIN}/modules`,
	ADMIN_MODULE: `${ADMIN}/modules/:moduleId`,
	ADMIN_LESSON: `${ADMIN}/modules/:moduleId/lessons/:lessonId`,
	ADMIN_OFFICE_HOURS: `${ADMIN}/office-hours`,
	ADMIN_USERS: `${ADMIN}/users`,
	ADMIN_USER: `${ADMIN}/users/:userId`,
	ADMIN_ACCESS_REQUESTS: `${ADMIN}/access-requests`,
} as const;
